import { Task } from '@app/models/tasks/task.model';
import { BadgeColumn } from '@app/modules/table/classes/badge-column.class';
import { CheckListFilter } from '@app/modules/table/classes/column-filters/check-list/check-list-filter.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { BadgeDisplay } from '@app/modules/table/interfaces/badge-display.interface';

export class TaskStatusColumn extends BadgeColumn<Task> {
    title = 'table.all-company-tasks.taskStatus';
    type: CellDisplay = CellDisplay.badge;

    constructor() {
        super();

        this.filter = new CheckListFilter('status', [
            { label: 'table.all-company-tasks.overdue', value: 'overdue', initiallyActive: true },
            { label: 'table.all-company-tasks.incomplete', value: 'incomplete', initiallyActive: true },
            { label: 'table.all-company-tasks.completed', value: 'completed' },
        ]);
    }

    getBadgeDisplay(task: Task): BadgeDisplay | null {
        if (task.isComplete()) {
            return {
                type: 'success',
                label: 'table.all-company-tasks.pillCompleted',
            };
        }

        if (task.isPastDueDay()) {
            return {
                type: 'danger',
                label: 'table.all-company-tasks.pillOverdue',
            };
        }

        return {
            type: 'default',
            label: 'table.all-company-tasks.pillIncomplete',
        };
    }
}
